import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "drg-name" }
const _hoisted_2 = { class: "drg-value" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = { class: "text-h8" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "row justify-start" }
const _hoisted_8 = { class: "col-1 weight" }
const _hoisted_9 = { class: "col-1 gmlos" }
const _hoisted_10 = {
  key: 0,
  class: "col-1 mdc"
}
const _hoisted_11 = {
  key: 1,
  class: "col-1 type"
}
const _hoisted_12 = {
  key: 2,
  class: "col-1 elix-mortality"
}
const _hoisted_13 = {
  key: 3,
  class: "col-1 elix-readmission"
}
const _hoisted_14 = {
  key: 4,
  class: "col-1 reimbursement"
}

import DisplayProperty from 'components/global-common/DisplayProperty.vue';
import { DrgResponseDto } from 'src/contracts/drgResponseDto';
import { computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useGrouperStore } from 'stores/grouper-store';

export interface Props {
  drgInfo?: DrgResponseDto;
  isApr: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DrgDisplay',
  props: {
    drgInfo: {},
    isApr: { type: Boolean, default: false }
  },
  setup(__props: any) {

const grouperStore = useGrouperStore();
const { aprCalculationAvailable, readOnly } = storeToRefs(grouperStore);
const descriptionRef = ref<HTMLElement | null>(null);

const shouldShowAprButton = computed(() => {
  return localStorage.getItem('apr_calculation_enabled') === 'true';
})

const props = __props;

const isApr = computed(() => props?.isApr);
const ccMccFlag = computed(() => {
  let flag = '';
  if (!props?.drgInfo?.diagnoses_results) {
    return flag;
  }
  for (let i = 0; i < props?.drgInfo?.diagnoses_results.length; i++) {
    if (props?.drgInfo?.diagnoses_results[i].mcc_flag) {
      return 'MCC';
    }
    if (flag != 'CC' && props?.drgInfo?.diagnoses_results[i].cc_flag) {
      flag = 'CC';
    }
  }

  return flag;
});

const isPrimary = computed(() => {
  return (isApr.value && !grouperStore.isPrimaryDrgMs) || (!isApr.value && grouperStore.isPrimaryDrgMs);
})

const shouldShowReimbursement = computed(() => {
  return localStorage.getItem('displayEstimatedReimbursement') === 'true';
})

const showSkeleton = computed(() => {
  return isApr.value && grouperStore.isCalculatingApr;
});

const showContent = computed(() => {
  return !isApr.value || !showSkeleton.value;
})

const isDescriptionOverflowing = computed(() => {
  if (!descriptionRef.value) return false;
  return descriptionRef.value.scrollWidth > descriptionRef.value.clientWidth;
});

function getNumberDisplay(value: number | null | undefined): string {
  return value?.toString() || '--';
}

function getReimbursementDisplay(value: number | undefined | null): string {
  return value ? `$${value.toFixed(2).toString()}` : '--';
}

async function calculateAprDrg() {
  await grouperStore.calculateApr();
}

function getTypeDisplay(value: string | undefined | null): string {
  switch (value) {
    case 'medical':
    case 'MED':
      return 'MED';
    case 'surgical':
    case 'SUR':
      return 'SUR';
    default:
      return '--';
  }
}

return (_ctx: any,_cache: any) => {
  const _component_q_skeleton = _resolveComponent("q-skeleton")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_chip = _resolveComponent("q-chip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", null, _toDisplayString(!isApr.value ? 'MS' : 'APR') + " DRG ", 1),
      _withDirectives(_createVNode(_component_q_skeleton, {
        type: "text",
        style: {"width":"80%","height":"30px"}
      }, null, 512), [
        [_vShow, showSkeleton.value]
      ]),
      (!isApr.value || !shouldShowAprButton.value)
        ? (_openBlock(), _createBlock(_component_q_space, {
            key: 0,
            class: "drg-button-spacer"
          }))
        : _createCommentVNode("", true),
      (isApr.value && shouldShowAprButton.value)
        ? (_openBlock(), _createBlock(_component_q_btn, {
            key: 1,
            unelevated: "",
            class: "iodine-icon-button text-none",
            disabled: !_unref(aprCalculationAvailable),
            onClick: calculateAprDrg,
            round: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_icon, {
                name: "fa-solid fa-arrows-rotate",
                size: "18px",
                class: _normalizeClass({enabled: _unref(aprCalculationAvailable), disabled: !_unref(aprCalculationAvailable), 'icon-spinner': _unref(grouperStore).isCalculatingApr})
              }, {
                default: _withCtx(() => [
                  (!_unref(readOnly))
                    ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(!_unref(aprCalculationAvailable) ? 'Calculation for APR DRG is currently unavailable' : 'Calculate APR DRG'), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 1
          }, 8, ["disabled"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("span", {
        class: _normalizeClass({'drg-primary': isPrimary.value, 'drg-secondary': !isPrimary.value})
      }, _toDisplayString(props?.drgInfo?.drg ?? '--'), 3), [
        [_vShow, showContent.value]
      ]),
      _withDirectives(_createVNode(_component_q_skeleton, {
        type: "text",
        style: {"width":"80%","height":"30px"}
      }, null, 512), [
        [_vShow, showSkeleton.value]
      ]),
      _hoisted_3,
      (!isApr.value && ccMccFlag.value)
        ? _withDirectives((_openBlock(), _createBlock(_component_q_chip, {
            key: 0,
            class: _normalizeClass(ccMccFlag.value)
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_4, _toDisplayString(ccMccFlag.value), 1)
            ]),
            _: 1
          }, 8, ["class"])), [
            [_vShow, showContent.value]
          ])
        : _createCommentVNode("", true),
      (isApr.value && props?.drgInfo?.drg)
        ? (_openBlock(), _createBlock(DisplayProperty, {
            key: 1,
            loading: showSkeleton.value,
            "loader-width": "15%",
            label: "SOI:",
            value: '' + props?.drgInfo?.soi,
            horizontal: true,
            size: "small",
            noTruncate: true
          }, null, 8, ["loading", "value"]))
        : _createCommentVNode("", true),
      (isApr.value && props?.drgInfo?.drg)
        ? (_openBlock(), _createBlock(DisplayProperty, {
            key: 2,
            loading: showSkeleton.value,
            "loader-width": "15%",
            label: "ROM:",
            value: '' + props?.drgInfo?.rom,
            horizontal: true,
            size: "small",
            noTruncate: true
          }, null, 8, ["loading", "value"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (showContent.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "col description ellipsis",
              ref_key: "descriptionRef",
              ref: descriptionRef
            }, [
              _createTextVNode(_toDisplayString(props?.drgInfo?.drg_description || (!_unref(aprCalculationAvailable) ? 'To begin calculating the DRG; add code via search bar, research view or directly into the table.' : '')) + " ", 1),
              (isDescriptionOverflowing.value)
                ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(props?.drgInfo?.drg_description || (!_unref(aprCalculationAvailable) ? 'To begin calculating the DRG; add code via search bar, research view or directly into the table.' : '')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], 512))
          : _createCommentVNode("", true),
        (showSkeleton.value)
          ? (_openBlock(), _createBlock(_component_q_skeleton, {
              key: 1,
              class: "col description"
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(DisplayProperty, {
            loading: showSkeleton.value,
            label: "Weight",
            value: getNumberDisplay(props?.drgInfo?.drg_weight)
          }, null, 8, ["loading", "value"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(DisplayProperty, {
            loading: showSkeleton.value,
            label: "GMLOS",
            value: getNumberDisplay(props?.drgInfo?.gmlos)
          }, null, 8, ["loading", "value"])
        ]),
        (isPrimary.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(DisplayProperty, {
                label: "MDC",
                value: props?.drgInfo?.mdc || '--'
              }, null, 8, ["value"])
            ]))
          : _createCommentVNode("", true),
        (isPrimary.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(DisplayProperty, {
                label: "Type",
                value: getTypeDisplay(props?.drgInfo?.drg_type)
              }, null, 8, ["value"])
            ]))
          : _createCommentVNode("", true),
        (isPrimary.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(DisplayProperty, {
                label: "Elix Mortality Index",
                value: getNumberDisplay(props?.drgInfo?.elixhauser_mortality_index),
                elipsizedTooltip: true
              }, null, 8, ["value"])
            ]))
          : _createCommentVNode("", true),
        (isPrimary.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(DisplayProperty, {
                label: "Elix Readmission Index",
                value: getNumberDisplay(props?.drgInfo?.elixhauser_readmission_index),
                elipsizedTooltip: true
              }, null, 8, ["value"])
            ]))
          : _createCommentVNode("", true),
        (isPrimary.value && shouldShowReimbursement.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createVNode(DisplayProperty, {
                label: "Est. Reimbursement",
                value: getReimbursementDisplay(props?.drgInfo?.drg_reimbursement),
                elipsizedTooltip: true
              }, null, 8, ["value"])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})